import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_private/_route/_internal/pipeline-submissions/$submissionId/',
)({
  beforeLoad: async () => {
    throw redirect({
      to: '/pipelines',
      search: {
        order: 'desc',
        sort: 'created',
        status: ['active'],
      },
    });
  },
});
